export default {
  club_name: 'Tromsø IL',
  club_name_short: 'tromso',
  stadium_name: '',
  staging_url: 'https://tromso.api.fangroup.io',
  prod_url: 'https://tromso.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/tromso',
  club_logo: '/assets/teams/tromso.png',
  app_name: 'tromso',
  websale_name: 'tromso',
  ntb_team_id: 10077,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'NOK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'tromso',
  monolithEnabled: false,
  clubWebsiteEnabled: false,
};
